<!--项目类型列表-->
<template>
   <div>
      <!--搜索栏-->
      <div class="contribute" v-show="false">
         <div class="inner_view">
            <div class="spanClass">
               <span style="line-height: 32px">项目名称:</span>
               <el-input v-model="filter.prjName" placeholder="请输入项目名称" @clear="searchData"
                         :clearable="true" style="margin-left: 10px;width: 200px;"></el-input>
            </div>
         </div>
         <div>
            <el-button type="primary" style="margin-left: 20px" @click="searchData">
               查询
            </el-button>
         </div>
      </div>
      <!--表格数据展示-->
      <div class="contribute tableContainer">
         <el-table :data="table.data" border ref="mainTable" row-key="rowID" v-loading="table.showLoading">
            <el-table-column type="index" :index="indexNo" label="序号" width="50" fixed="left"></el-table-column>
            <div v-for="(item,index) in table.column" :key="index">
               <el-table-column :prop="item.prop" :label="item.label" :width="item.width"></el-table-column>
            </div>
            <el-table-column fixed="right" label="操作">
               <template v-slot="scope">
                  <el-button type="text" size="small" @click="rowUpload(scope.row)">
                     上传推荐资料
                  </el-button>
                  <el-button type="text" size="small" @click="rowDetail(scope.row)">
                     查看明细
                  </el-button>
                  <!--浙江绿色工程，统一推荐操作取消-->
                  <el-button type="text" v-show="false" v-if="scope.row.recomCount==0" size="small"
                             @click="rowRecom(scope.row)">
                     统一推荐
                  </el-button>
               </template>
            </el-table-column>
         </el-table>
      </div>
      <!--分页栏-->
      <div style="margin-top: 50px;" v-if="pager.rowCount>10">
         <el-pagination background :layout="pager.layout" :current-page="pager.pageIndex" :page-size="pager.pageSize"
                        :total="pager.rowCount" @size-change="pageSizeChange"
                        @current-change="pageIndexChange"></el-pagination>
      </div>
      <!--要展示的对话框-->
      <div class="dialog">
         <uploadDialog ref="upload" @uploadCompleted="_uploadComplete"></uploadDialog>
      </div>
   </div>
</template>

<script>
   import {getUploadFiles} from '@/api/modules/paUploadedFile.js'
   import {applyUnifyRecom} from '@/api/modules/project'
   import {getProjectList_Recom} from '@/api/modules/project'
   import uploadDialog from "@/views/greenEngineerRecom/components/uploadDialogRecom";

   export default {
      data() {
         return {
            filter: {
               prjName: ''
            },
            pager: {
               layout: 'total, sizes, prev, pager, next, jumper',
               pageIndex: 1,
               pageSize: 10,
               rowCount: 0,
            },
            table: {
               data: [],
               //表格列配置
               column: [{'prop': 'project_name', 'label': '项目名称'},
                  {'prop': 'apply_date', 'label': '申报时间', width: 200},
                  {'prop': 'submitCount', 'label': '已提交', width: 70},
                  {'prop': 'returnCount', 'label': '已退回', width: 70},
                  {'prop': 'disagreeCount', 'label': '不同意', width: 70},
                  {'prop': 'auditCount', 'label': '已审核', width: 70},
                  {'prop': 'recomCount', 'label': '已推荐', width: 70},
                  {'prop': 'statusShow', 'label': '状态', width: 100},],
               showLoading: false
            },
            ddl: {
               //处理状态
               statusList: [{'text': '未提交', 'value': '0'}, {'text': '已提交', 'value': '1'}]
            }
         }
      },
      components: {
         uploadDialog
      },
      created() {
         this.searchData()
      },
      computed: {
         //计算行号
         indexNo() {
            return this.pager.pageSize * (this.pager.pageIndex - 1) + 1
         },
      },
      methods: {
         /*统一推荐*/
         async rowRecom(row) {
            this.$confirm('统一推荐只允许操作一次，确认统一推荐?').then(() => {
               const param = {
                  project_code: row.project_code,
                  //推荐单位公司编号
                  company_code: localStorage.getItem('company_code')
               };
               applyUnifyRecom({
                  data: param,
                  success: (res) => {
                     this.$message.success("推荐完成");
                     this.searchData();
                  }
               })
            });
         },
         /*上传推荐资料*/
         rowUpload(row) {
            //获取已上传的附件列表
            const param = {
               project_code: row.project_code,
               recommended_unit: localStorage.getItem('company_code')
            }
            getUploadFiles({
               data: param,
               success: (res) => {
                  const fileList = [];
                  for (let item of res.data.list.values()) {
                     console.log('item=',item)
                     fileList.push({
                        url: item.path_url,
                        name: item.file_name
                     })
                  }
                  console.log(fileList)
                  this.$refs['upload'].showDialog(row.project_code, '*', fileList)
               }
            })
         },
         /*上传完毕后的回调*/
         _uploadComplete() {

         },
         /*查看明细*/
         async rowDetail(row) {
            /*绿色工程*/
            if (row.project_type == 18)
               this.$router.push('/index/greenEngineerRecom/applyList')
         },
         //获取项目数据
         async searchData() {
            const params = {
               ...this.filter,
               //门户类型
               portalType: localStorage.getItem('portalType'),
               //登录账号归属企业
               company_code: localStorage.getItem("company_code"),
               pageIndex: this.pager.pageIndex,
               pageSize: this.pager.pageSize
            }
            this.loading = true
            await getProjectList_Recom({
               data: params,
               success: (res) => {
                  this.table.data = res.data.list;
                  this.pager.rowCount = res.data.pageInfo.rowCount
                  this.loading = false
               }
            })
         },
         //换页切换
         pageIndexChange(val) {
            this.pager.pageIndex = val
            this.searchData()
         },
         //分页数量切换
         pageSizeChange(val) {
            this.pager.pageSize = val
            this.searchData()
         },
         //显示模态对话框
         showDialog(type, row) {
            this.$refs[type].showDialog(row);
         },
      }
   }
</script>

<style scoped="scoped">

   .tableContainer {
      width: 100%;
      min-height: 90px;
      height: auto;
      background-color: #f9f9f9;
   }

   .tableContainer thead th {
      background-color: #dce0e6 !important;
      font-weight: bold;
      font-size: 15px;
      width: calc(100% - 2px);
   }

   .contribute {
      display: flex;
      margin: 20px 0;
      display: flex;
      align-items: center;
      justify-content: space-between;
      min-height: 40px;
   }

   .inner_view {
      line-height: 50px;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      align-content: space-around;
      justify-content: flex-start;
   }

   .spanClass {
      line-height: 32px;
      margin-left: 20px;
   }

</style>
